import html2canvas from 'html2canvas'
import Cookies from 'js-cookie'
import jsPDF from 'jspdf'

export const getSessionId = (): string | undefined => {
  try {
    return Cookies.get('session_id')
  } catch (error) {
    console.error('Error retrieving session_id:', error)
    return undefined
  }
}

export const getCaseId = (): string | undefined => {
  try {
    return Cookies.get('case_id')
  } catch (error) {
    console.error('Error retrieving case_id:', error)
    return undefined
  }
}

export const formatPathnameToTitle = (pathname: string = ''): string => {
  if (typeof pathname !== 'string') {
    console.warn(
      'Invalid pathname provided to formatPathnameToTitle:',
      pathname,
    )
    return ''
  }

  return pathname
    .split('/')
    .filter((segment: string): boolean => Boolean(segment))
    .map((segment: string): string =>
      segment
        .replace(/-/g, ' ')
        .replace(/\b\w/g, (char: string): string => char.toUpperCase()),
    )
    .join(' : ')
}

export const stringToColor = (string: string) => {
  let hash = 0
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
  }
  let color = '#'
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff
    color += ('00' + value.toString(16)).substr(-2)
  }
  return color
}

export const isNullorEmpty = (...args: any[]) => {
  let result = true
  let res = args[0]
  if (!res) return false
  // let result = !!res;
  if (!res) return false
  for (let i = 1; i < args.length && result; i++) {
    res = res[args[i]]
    // if (!res) return false; old code returning false with 0 number
    if (!res && res !== 0) return false
    if (Array.isArray(res)) result = res.length > 0
  }
  return result
}

export const isNullorEmptyArr = (...args: any[]) => {
  let result = true
  for (let i = 0; i < args.length; i++) {
    if (!isNullorEmpty(...args[i])) return false
  }
  return result
}

export const generatePdfForAnalogOrRecipe = async ({
  inputElementName,
  outputPdfName,
}: {
  inputElementName: string
  outputPdfName: string
}) => {
  const pdf = new jsPDF({ unit: 'pt', format: 'a4' })
  let inputList: any = document.getElementsByClassName(inputElementName)
  for (let i = 0; i < inputList.length; i++) {
    if (i !== 0) pdf.addPage()
    var divHeight = inputList[i].clientHeight
    var divWidth = inputList[i].clientWidth
    var ratio = divHeight / divWidth
    await html2canvas(inputList[i]).then((canvas) => {
      const imgData = canvas.toDataURL('image/png', 1.0)
      var width = pdf.internal.pageSize.getWidth() // 210 //597
      var height = pdf.internal.pageSize.getHeight() // 297 //842
      height = ratio * width
      if (597 / divWidth > 842 / divHeight) {
        width = (802 * divWidth) / divHeight
        height = 802
        let startPos = (597 - width) / 2 > 0 ? (597 - width) / 2 : 0
        pdf.addImage(
          imgData,
          'JPEG',
          startPos,
          0,
          width,
          842,
          undefined,
          'FAST',
        )
      } else {
        height = (577 * divHeight) / divWidth
        width = 577
        pdf.addImage(imgData, 'JPEG', 10, 20, width, height, undefined, 'FAST')
      }
    })
  }
  pdf.save(`${outputPdfName}.pdf`)
}
